import BundleView from "./BundleView";

export default BundleView;
